import Api from "@/services/Api";

// var config = {
//   headers: {
//     'Access-Control-Allow-Origin': '*'
//   }
// };

export default {
  register(credentials) {
    return Api().post("admin", credentials);
  },
  login(credentials) {
    return Api().post("login.php", credentials);
  }
};
